// biome-ignore lint/style/useFilenamingConvention: TanStack Router dynamic route parameter
import { createFileRoute } from "@tanstack/react-router";
import {
  orgCapabilitiesQueryOptions,
  projectCapabilitiesQueryOptions,
} from "@/app/capabilities/api/get-capabilities";
import { Layout } from "@/components/custom/layout";
import { OrgProjectRouteError } from "@/lib/org-project-context/constants";
import { OrgProjectErrorFallback } from "@/lib/org-project-context/error-fallbacks";
import { resolveDashboardOrgProjectRoute } from "@/lib/org-project-context/hooks";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId"
)({
  beforeLoad: async ({ params, context }) => {
    const result = await resolveDashboardOrgProjectRoute(
      context.queryClient,
      params
    );

    if (result.outcome !== "valid") {
      throw new OrgProjectRouteError(result);
    }

    // Awaited so the sidebar's permission gates read from cache (no flicker).
    // Org capabilities back `<CanOrg>` in the project switcher; the fetch fails
    // closed on the Org-Admin-only feed rather than throwing, so this is safe.
    await Promise.all([
      context.queryClient.ensureQueryData(
        projectCapabilitiesQueryOptions({
          organizationId: result.organizationId,
          projectId: result.projectId,
        })
      ),
      context.queryClient.ensureQueryData(
        orgCapabilitiesQueryOptions(result.organizationId)
      ),
    ]);

    return {
      organizationId: result.organizationId,
      projectId: result.projectId,
      organizations: result.organizations,
      projects: result.projects,
    };
  },
  component: Layout,
  errorComponent: OrgProjectErrorFallback,
});
